<template>
  <div class="idea-head text-medium">
    <div class="row-wrapper">
      <div class="row no-gutters">
        <div class="cell title-cell ml-1 col pb-1 pointer">
          <sort-dropdown
            title="Ideas"
            column-key="title"
            align="left"
            :sort-options="sortOptions.title"
            :sorted-direction="sortedDirection"
            :sorted-by="sortedBy"
            :show-filter-options="showFilterOptions"
            @sort="onSort"
            @reset="$emit('reset')"
          />
        </div>
        <div class="cell text-center pb-1 dropdown-cell pointer">
          <sort-dropdown
            title="Reach"
            column-key="reach"
            :sort-options="sortOptions.reach"
            :sorted-direction="sortedDirection"
            :sorted-by="sortedBy"
            :filter-options="filterOptions.reach"
            :filtered-by="filteredBy && filteredBy.reach"
            :show-filter-options="showFilterOptions"
            @sort="onSort"
            @reset="$emit('reset')"
            @filter="onFilter({ filterParam: 'reach', ...$event })"
          />
        </div>
        <div class="cell text-center pb-1 dropdown-cell pointer">
          <sort-dropdown
            title="Effort"
            column-key="effort"
            :sort-options="sortOptions.effort"
            :sorted-direction="sortedDirection"
            :sorted-by="sortedBy"
            :filter-options="filterOptions.effort"
            :filtered-by="filteredBy && filteredBy.effort"
            :show-filter-options="showFilterOptions"
            @sort="onSort"
            @reset="$emit('reset')"
            @filter="onFilter({ filterParam: 'effort', ...$event })"
          />
        </div>
        <div class="cell text-center pb-1 dropdown-cell pointer">
          <sort-dropdown
            title="Impact"
            column-key="impact"
            :sort-options="sortOptions.impact"
            :sorted-direction="sortedDirection"
            :sorted-by="sortedBy"
            :filter-options="filterOptions.impact"
            :filtered-by="filteredBy && filteredBy.impact"
            :show-filter-options="showFilterOptions"
            @sort="onSort"
            @reset="$emit('reset')"
            @filter="onFilter({ filterParam: 'impact', ...$event })"
          />
        </div>
        <div class="cell col-1 text-center pb-1 owner-cell pointer">
          <sort-dropdown
            title="Owner"
            column-key="owner"
            :sort-options="sortOptions.owner"
            :sorted-direction="sortedDirection"
            :sorted-by="sortedBy"
            @sort="onSort"
            @reset="$emit('reset')"
          />
        </div>
        <div class="overflow-plc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { FILTER_OPTIONS } from '@/constants/initiative'
import * as R from 'ramda'
import { trackEvent } from '@/analytics'
import SortDropdown from '@/components/SortDropdown'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'

/**
 * This is the header component for list of ideas table
 * @emit
 * - sort: this is emitted when sorting is applied on any column
 * - filter: this is emitted when filtering is applied on any column
 */
export default {
  name: 'IdeaHeader',
  props: {
    sortedBy: {},
    sortedDirection: {},
    filteredBy: { default: () => ({}) },
    showFilterOptions: { default: true }
  },
  components: { SortDropdown },
  data() {
    const alphabeticalSortOptions = [
      { title: 'A → Z', direction: 'ascending' },
      { title: 'Z → A', direction: 'descending' }
    ]
    const serveritySortOptions = [
      { title: 'High → Low', direction: 'descending' },
      { title: 'Low → High', direction: 'ascending' }
    ]
    return {
      sortOptions: {
        title: alphabeticalSortOptions,
        impact: serveritySortOptions,
        effort: serveritySortOptions,
        reach: serveritySortOptions,
        dueDate: [
          { title: 'Earliest First', direction: 'ascending' },
          { title: 'Latest First', direction: 'descending' }
        ],
        owner: alphabeticalSortOptions,
        status: alphabeticalSortOptions
      },
      filterOptions: FILTER_OPTIONS
    }
  },
  methods: {
    sendEvent(field, addEvent) {
      switch (field) {
        case 'title':
          addEvent(EVENT_NAME.TITLE)
          break
        case 'impact':
          addEvent(EVENT_NAME.IMPACT)
          break
        case 'owner':
          addEvent(EVENT_NAME.OWNER)
          break
        case 'reach':
          addEvent(EVENT_NAME.REACH)
          break
        case 'effort':
          addEvent(EVENT_NAME.EFFORT)
          break
      }
    },
    addFilterAnalytics({ filterParam }) {
      const addEvent = R.curryN(3, trackEvent)(EVENT_CATEGORY.PREFERENCE, EVENT_ACTION.FILTER_IDEAS)
      this.sendEvent(filterParam, addEvent)
    },
    addSortAnalytics({ by }) {
      const addEvent = R.curryN(3, trackEvent)(EVENT_CATEGORY.PREFERENCE, EVENT_ACTION.SORT_IDEAS)
      this.sendEvent(by, addEvent)
    },
    onSort(sortParams) {
      this.$emit('sort', sortParams)
      this.addSortAnalytics(sortParams)
    },
    onFilter(payload) {
      this.$emit('filter', payload)
      this.addFilterAnalytics(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.idea-head {
  color: $secondary;
  user-select: none;
}

.title-cell {
  padding-left: 15px;
}

// TODO: Support SortDropown to accept align property
.title-cell /deep/ .field {
  justify-content: flex-start;
}

.overflow-plc {
  width: 36px;
}

.dropdown-cell {
  width: 80px;
}

.row-wrapper > .row {
  padding-left: 30px;
}
</style>
